import { useContext } from "react";

import { PrivacyModeContext } from "./Context";

export function usePrivacyMode() {
  return useContext(PrivacyModeContext);
}

export default usePrivacyMode;
